<div class='modal-dropdown w-100' ngbDropdown>
    <span class="modal-dropdown-caption" [class.text-error]="!selected && didSubmit && !source.data.name_parent">{{namesInfo.destination}}</span>
  <div class="modal-dropdown-selector" ngbDropdownToggle  (click)="handleDropdown()">
    <span class="modal-button" [class.is-placeholder]='title === "Select a folder"'> {{title}} </span>
    <i class="root-icon root-icon-variant icon-size-24" [ngClass]="{'ic-chevron-down': !dropdown, 'ic-chevron-up': dropdown}"></i>
  </div>
  <div class="modal-dropdown-content modal-vh w-100">
    <div class="modal-body-content modal-overflow w-100 viewport-h-33" ngbDropdownMenu>
      <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ $implicit: entities }"></ng-container>
    </div>
    <ng-template #recursiveListTmpl let-items>
      <div id="root-{{getId(items)}}" class="accordion">
        <div *ngFor='let entity of items' class="root-container d-flex w-100 flex-column">
          <button
            id="button-{{entity.id}}"
            type="button" class="root-element collapsed"
            [attr.data-toggle]="'collapse'"
            [attr.data-target]="'#children-'+ entity.id"
            [attr.aria-controls]="'children-'+entity.id"
            (click)='handleCollapse(entity)'>
            <div class="root-element-info">
              <img class="ws-img" [src]="getEntityIcon(entity)" />
              <span class='root-element-title' [class.active]="isMe(entity)">{{entity.name}}</span>
              <i
                *ngIf='hasChildren(entity) && !isMe(entity)'
                class="root-icon"
                [ngClass]="{'ic-chevron-up': entity.collapse, 'ic-chevron-down': !entity.collapse}"
              ></i>
            </div>
            <div *ngIf='isMovable(entity)' class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="checked-{{entity.id}}"
                [checked]='entity.checked'
                (click)='select(entity)'>
              <label class="custom-control-label" for="checked-{{entity.id}}"></label>
            </div>
          </button>
          <div
            *ngIf='hasChildren(entity) && !isMe(entity)'
            id="children-{{entity.id}}"
            class="root-children collapse"
            [attr.aria-labelledby]="'button-'+entity.id"
            [ngClass]="{'show' : isOpen(entity)}"
            [attr.data-parent]="'#root-'+getId(items)">
            <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ $implicit: entity.children }"></ng-container>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
